import React, { FunctionComponent } from 'react'

import { useTheme } from 'styled-components/native'

import { useGetResponsiveAssets } from '../../hooks/useGetResponsiveAssets'
import { tID } from '../../utils'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { BackgroundImageContainer } from '../backgroundImageContainer/BackgroundImageContainer'

export const WellnessCheckInBackgroundContainer: FunctionComponent = ({ children }) => {
  const {
    assets: { wellnessCheckInBackground },
  } = useTheme() as ThemeType

  const backgroundImage = useGetResponsiveAssets(wellnessCheckInBackground.assetNames)

  return (
    <BackgroundImageContainer
      backgroundImageUrl={backgroundImage}
      centerBackgroundImage={false}
      testID={tID('WellnessCheckInBackgroundContainer')}
    >
      {children}
    </BackgroundImageContainer>
  )
}
